// src/belediye/components/mesajlasma/useMobilKlavye.js
// FAZ-83/5 — "KLAVYE AÇILMASI BURADA PAHALI MI?"
//
// Kullanıcı (2026-08-01): "mobildeki klavye açılması gibi hareketleri
// detaylıca tüm telefon modelleri için hesapla… klavye bir açılıp bir
// kapanmasın. Yazı yazılmayan yerlerde klavyenin açılmasına gerek var mı yok
// mu buna göre ayarla… örneğin mahallede hem arama yapılıyor hem seçim, bu
// ekranı çok kapatıyor."
//
// Masaüstünde klavye HİÇBİR ŞEYİ kapatmaz; alanı otomatik odaklamak orada
// sadece kolaylıktır. Dokunmatikte ise yazılım klavyesi ekranın yarısını
// yiyor: kendiliğinden açılan bir arama kutusu, seçilecek listeyi görünmez
// kılıyor. Bu kanca o ayrımı TEK yerden verir.
//
// ÖLÇÜT — ekran genişliği DEĞİL, giriş aygıtı + genişlik birlikte:
//   • `pointer: coarse`  → parmakla kullanılan her cihaz (telefon VE tablet;
//     iPad'de de klavye ekranın yarısını kapatıyor, ayrı davranmasına gerek
//     yok). Model listesi tutmuyoruz — "hangi telefon" sorusunu tarayıcının
//     kendi yeteneği cevaplıyor, böylece yeni çıkan modeller de kapsanır.
//   • `max-width: 640px` → dokunmatik bildirmeyen ama dar olan yüzeyler
//     (masaüstünde daraltılmış pencere, bazı hibrit cihazlar).
// İkisinden biri yeterlidir.
import { useEffect, useState } from "react";

export const MOBIL_SORGU = "(pointer: coarse), (max-width: 640px)";

export default function useMobilKlavye() {
  const [mobil, setMobil] = useState(
    () => typeof window !== "undefined" && !!window.matchMedia?.(MOBIL_SORGU).matches
  );

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mq = window.matchMedia(MOBIL_SORGU);
    const uygula = (e) => setMobil(e.matches);
    setMobil(mq.matches);
    // Safari 13 ve öncesi addEventListener bilmiyor — eski API'ye düş.
    if (mq.addEventListener) {
      mq.addEventListener("change", uygula);
      return () => mq.removeEventListener("change", uygula);
    }
    mq.addListener(uygula);
    return () => mq.removeListener(uygula);
  }, []);

  return mobil;
}
